import { AlertColor, Box, Card, Grid } from '@mui/material';
import { useEffect, useRef, useState, useContext } from 'react';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import { Formik, FormikProps } from 'formik';
import TitleText from '../../components/formlib/TitleText';
import {
  DropDownList,
  EICSForm,
  EICSTransitionLookupValues,
  OptionType,
  SignatureStateType,
} from '../../utils/type';
import * as yup from 'yup';
import CustomBackArrow from '../../components/imagepickers/backArrow';
import MediumTypography from '../../components/formlib/MediumTypography';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import {
  addTransitionData,
  getEICSLookupValues,
  getTransitiondata,
} from '../../services/eicsTransitionApi/EicsTransitionApi';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import ModalPopup from '../../components/formlib/ModalPopup';
import { useNavigate } from 'react-router';
import { EICS_TBR, FACESHEET } from '../../routes/Routing';
import dayjs, { Dayjs } from 'dayjs';
import { checkPermissionForFeature } from '../../utils/checkPermission';
import { ReactComponent as GoTo } from '../../assets/images/goTo.svg';
import { datePickerMinDateMaxDateValidate } from '../../utils/dateUtil';
import SignatureComponent from '../../components/formlib/modal/SignatureComponent';
import { ReactComponent as Editsignature } from '../../assets/images/editsignature.svg';
import _ from 'lodash';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import { useMultiplePermissions } from '../../hooks/usePermissions';
import {
  REFERRAL_ID_KEY,
  REFERRAL_PROGRAM_KEY,
  REFERRAL_STATUS_KEY,
  SELECTED_PROGRAM_KEY,
} from '../../services/Constant';
import { ReferralResponseType } from '../../services/configApi/Clients';

interface UnsavedChangesWatcherProps {
  values: EICSForm;
  eicsAndTbrData: EICSForm;
  onUnsavedChangesChange: (hasUnsavedChanges: boolean) => void;
}

const UnsavedChangesWatcher = ({
  values,
  eicsAndTbrData,
  onUnsavedChangesChange,
}: UnsavedChangesWatcherProps) => {
  useEffect(() => {
    const hasUnsavedChanges = !_.isEqual(eicsAndTbrData, values);

    onUnsavedChangesChange(hasUnsavedChanges);
  }, [values, eicsAndTbrData, onUnsavedChangesChange]);

  return null;
};

function EICSTBRTransitionAndDischargeInformation() {
  const clientId = localStorage.getItem('ClientId');
  const navigation = useNavigate();
  const [signClicked, setSignClicked] = useState<boolean>(false);
  const [changed, setChanged] = useState<boolean>(false);

  useEffect(() => {
    toggleLoader(true);
    getEICSLookupValues()
      .then((response: EICSTransitionLookupValues) => {
        setReferralDischargeReasonData(response.referralDischargeReason);
        getTransitiondataFunction();
      })
      .catch((error) => {
        toggleLoader(false);
        setSuccessOrError('error');
        setToastrId(error.message);
        setToastrDefaultMessage(error.message);
      });
  }, []);

  const getTransitiondataFunction = () => {
    toggleLoader(true);
    getTransitiondata(clientId)
      .then((response: EICSForm) => {
        if (formRef.current) {
          formRef.current.setValues({
            ...response,
          });
        }
        const referralId = localStorage.getItem(REFERRAL_ID_KEY);
        const clientReferralDetails = localStorage.getItem(
          'clientReferralDetails',
        );
        if (referralId && clientReferralDetails) {
          const referrals = JSON.parse(
            clientReferralDetails,
          ) as ReferralResponseType[];
          const referral = referrals.find((re) => re.referralId === referralId);
          if (referral && (referral.dphId || referral.dphId !== '')) {
            localStorage.setItem(
              REFERRAL_STATUS_KEY,
              response.dischargeApproved ? 'Inactive' : 'Active',
            );
          } else {
            localStorage.setItem(
              REFERRAL_STATUS_KEY,
              response.dischargeApproved ? 'Inactive' : 'Pending',
            );
          }
        } else {
          localStorage.setItem(
            REFERRAL_STATUS_KEY,
            response.dischargeApproved ? 'Inactive' : 'Pending',
          );
        }
        setDischargeData(response);
        setEicsAndTbrData(response);

        if (response.dischargeApproved) {
          setTcsFlag(true);
        }
        toggleLoader(false);
      })
      .catch((error) => {
        toggleLoader(false);
        setSuccessOrError('error');
        setToastrId(error.message);
        setToastrDefaultMessage(error.message);
      });
  };

  const initialValues: EICSForm = {
    transitionPlan: '',
    transitionPlanDate: null,
    noTransitionPlanReason: '',
    leaEligible: '',
    leaReferralConsent: '',
    leaReferralConsentDate: null,
    leaReferralReason: '',
    tpcDate: null,
    noTPCReason: '',
    outsideTPCReason: '',
    dischargeDate: null,
    dischargeReason: '',
    includeDischargeInfoInNextEMR: false,
    allowApprove: false,
    signature: {
      name: '',
      relationship: '',
      email: '',
      signature: '',
      rowKey: '',
      partitionKey: '',
      verbal: false,
      id: '',
      date: '',
      license: '',
      isPrimary: false,
      isLegal: false,
      isGuardian: false,
    },
    appSource: '',
    dischargeApproved: false,
    unDischarged: false,
  };

  const formRef = useRef<FormikProps<EICSForm>>(null);
  const [eicsAndTbrData, setEicsAndTbrData] = useState<EICSForm>(initialValues);
  const [dischargeData, setDischargeData] = useState<EICSForm>();
  const bkpEicsAndTbrDataRef = useRef<EICSForm>();
  const dischargeDataEICSForm = useRef<EICSForm>();

  const [referralDischargeReasonData, setReferralDischargeReasonData] =
    useState<DropDownList[]>([]);
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  const { hasUnsavedChanges, handleUpdateUnsavedChanges } = useContext(
    UnSavedChangesContext,
  );
  const [toastrDefaultMessage, setToastrDefaultMessage] = useState('');
  const [toastrId, setToastrId] = useState<string>();
  const [cancelModal, setCancelModal] = useState<boolean>(false);
  const [approveModal, setApproveModal] = useState<boolean>(false);
  const [successOrError, setSuccessOrError] = useState<AlertColor>('success');
  const [tcsFlag, setTcsFlag] = useState<boolean>(false);
  const [openUnSavedModal, setOpenUnSavedModal] = useState<boolean>(false);
  const [openDischargeValidation, setOpenDischargeValidation] =
    useState<boolean>(false);
  const parentRef = useRef<HTMLDivElement>(null);

  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
  ]);
  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';
  const referralProgram = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  const selectedProgram = JSON.parse(
    localStorage.getItem(SELECTED_PROGRAM_KEY) ?? '',
  ) as OptionType;
  const hasEditPermission =
    referralStatus === 'Inactive'
      ? permissions['backend.clients'].canEdit &&
        permissions['backend.in_active_referrals'].canEdit
      : (permissions['backend.clients'].canEdit ||
          permissions['backend.in_active_referrals'].canEdit) &&
        referralProgram === selectedProgram?.id;
  const validationSchema = yup.object().shape({
    transitionPlanDate: yup.string().nullable(),

    includeDischargeInfoInNextEMR: yup.boolean().default(false),

    noTransitionPlanReason: yup.string().nullable(),

    leaReferralReason: yup.string().nullable(),

    leaReferralConsent: yup.string().when('leaEligible', {
      is: 'Yes',
      then: yup.string().nullable(),
      otherwise: yup.string().nullable(),
    }),

    leaReferralConsentDate: yup.string().nullable(),
  });

  const validateForm = (value: EICSForm) => {
    const errors: Partial<EICSForm> = {};

    if (
      datePickerMinDateMaxDateValidate(value.transitionPlanDate) ||
      datePickerMinDateMaxDateValidate(value.dischargeDate) ||
      datePickerMinDateMaxDateValidate(value.leaReferralConsentDate) ||
      datePickerMinDateMaxDateValidate(value.tpcDate)
    ) {
      errors.dischargeDate = 'datePickerMinDateMaxDateValidate';
      errors.tpcDate = 'datePickerMinDateMaxDateValidate';
      errors.transitionPlanDate = 'datePickerMinDateMaxDateValidate';
      errors.leaReferralConsentDate = 'datePickerMinDateMaxDateValidate';
    }
    return errors;
  };

  const transformedArrayDischareReason = referralDischargeReasonData.map(
    (item) => {
      const label = `${item.description}`;

      return {
        id: item.code,
        label,
      };
    },
  );

  const handleSave = (values: EICSForm, appointmentsDeleteCheck: boolean) => {
    toggleLoader(true);
    values.appointmentsDelete = appointmentsDeleteCheck;
    addTransitionData(values, clientId)
      .then((response) => {
        toggleLoader(false);
        setChanged(false);
        setSuccessOrError('success');
        setToastrId(response.message);
        setToastrDefaultMessage('Discharge saved successfully');
        getTransitiondataFunction();
      })
      .catch((error) => {
        if (error.code === 1113) {
          if (bkpEicsAndTbrDataRef.current)
            setEicsAndTbrData(bkpEicsAndTbrDataRef.current);
          setSuccessOrError('error');
          setToastrId(error.message);
          setToastrDefaultMessage(error.message);
        } else if (error.code === 1054) {
          setOpenDischargeValidation(true);
        } else if (error.code === 1179) {
          setSuccessOrError('error');
          setToastrId(error.message);
          setToastrDefaultMessage(
            'The employee has completed progress notes in the future and are onhold. You cannot Discharge',
          );
        } else {
          setSuccessOrError('error');
          setToastrId(error.message);
          setToastrDefaultMessage(error.message);
        }
        toggleLoader(false);
      });
  };

  const onSignatureSave = (sign: string) => {
    setSignClicked(!signClicked);
    setEicsAndTbrData({
      ...eicsAndTbrData,
      signature: {
        ...eicsAndTbrData.signature,
        partitionKey: '',
        rowKey: '',
        signature: sign,
      },
    });
  };

  const clearSignature = () => {
    bkpEicsAndTbrDataRef.current = eicsAndTbrData;

    setEicsAndTbrData({
      ...eicsAndTbrData,
      unDischarged: true,
      signature: {
        ...eicsAndTbrData.signature,
        partitionKey: '',
        rowKey: '',
        signature: '',
      },
    });

    formRef.current?.setFieldValue('signature.signature', '');
    setTcsFlag(false);
    setSignClicked(!signClicked);
    //set useRef for discharge data
    const values = {
      ...eicsAndTbrData,
      unDischarged: true,
      signature: {
        ...eicsAndTbrData.signature,
        partitionKey: '',
        rowKey: '',
        signature: '',
      },
    };
    dischargeDataEICSForm.current = values;
    handleSave(values, false);
  };

  const signatureCallBack = (response: SignatureStateType[]) => {
    setEicsAndTbrData({
      ...eicsAndTbrData,
      signature: {
        ...eicsAndTbrData.signature,
        partitionKey: response[0].partitionkey,
        rowKey: response[0].rowkey,
        signature: response[0].signaturedata,
      },
    });
  };

  const handleSuccess = (successError: AlertColor, id: string, mes: string) => {
    setSuccessOrError(successError);
    setToastrId(id);
    setToastrDefaultMessage(mes);
  };

  const handlePermissionCheck = () => {
    if (
      checkPermissionForFeature('backend.un_discharge', 'editPermission') &&
      hasEditPermission
    ) {
      return false;
    } else {
      return true;
    }
  };

  const onCancelClick = () => {
    setSignClicked(!signClicked);
  };

  return (
    <Formik
      initialValues={eicsAndTbrData}
      validationSchema={validationSchema}
      validate={validateForm}
      validateOnChange
      enableReinitialize={true}
      innerRef={formRef}
      onSubmit={(values) => {
        if (values.dischargeReason === null && values.dischargeDate !== null) {
          setSuccessOrError('error');
          setToastrId('EICS.DischargeReasonRequired');
          setToastrDefaultMessage('Discharge Reason is required');
        } else if (
          values.dischargeReason !== null &&
          values.dischargeDate === null
        ) {
          setSuccessOrError('error');
          setToastrId('EICS.DischargeDateRequired');
          setToastrDefaultMessage('Discharge Date is required');
        } else {
          //set useRef for discharge data
          dischargeDataEICSForm.current = values;
          handleSave(values, false);
        }
      }}
    >
      {({ values, setFieldValue, errors, touched, handleSubmit }) => {
        return (
          <Box component={'main'}>
            <UnsavedChangesWatcher
              values={values}
              eicsAndTbrData={eicsAndTbrData}
              onUnsavedChangesChange={handleUpdateUnsavedChanges}
            />
            <Box ref={parentRef}>
              <Box component="section">
                {toastrId && (
                  <SnackBarComponent
                    open={toastrId !== undefined}
                    handleClose={() => {
                      setToastrId(undefined);
                    }}
                    labelId={toastrId}
                    defaultMessageId={toastrDefaultMessage}
                    successOrError={successOrError}
                  />
                )}
                <ModalPopup
                  open={openDischargeValidation}
                  description="dischargeValidation"
                  labelId1="dischargeValidationNo"
                  labelId2="dischargeValidationYes"
                  negativeActionLabel="No"
                  positiveActionLabel="Yes"
                  onCancel={() => {
                    setOpenDischargeValidation(false);
                  }}
                  onOk={() => {
                    if (dischargeDataEICSForm.current) {
                      setOpenDischargeValidation(false);
                      handleSave(dischargeDataEICSForm.current, true);
                    }
                  }}
                />
                <ModalPopup
                  open={openUnSavedModal}
                  description="UnsavedAlertDescriptionWhileLeaving"
                  labelId1="UnSavedAlertCancel"
                  labelId2="UnSavedAlertLeave"
                  negativeActionLabel="No"
                  positiveActionLabel="Yes"
                  onCancel={() => {
                    setOpenUnSavedModal(false);
                  }}
                  onOk={() => {
                    navigation(FACESHEET);
                    handleUpdateUnsavedChanges(false);
                    setOpenUnSavedModal(false);
                  }}
                />
                <Box component={'div'} className="rowContainer">
                  <CustomBackArrow
                    onClick={() => {
                      if (hasUnsavedChanges) {
                        setOpenUnSavedModal(true);
                      } else {
                        handleUpdateUnsavedChanges(false);
                        navigation(FACESHEET);
                      }
                    }}
                  />
                  <Box component="div" className="ml-md">
                    <TitleText
                      labelid="DischargeText"
                      defaultlabel="Discharge"
                    />
                  </Box>
                </Box>
                <Card className="formCardview">
                  <Box>
                    <Box>
                      <MediumTypography
                        labelid="EICS.DischargeInformation"
                        defaultlabel={`Discharge Information`}
                        fontSize="16px"
                        fontweight={600}
                      />
                    </Box>
                    <Box>
                      <Grid container rowSpacing={'24px'} className="pt-md">
                        <Grid item xs={4}>
                          <DatePickerComponent
                            labelid="EICS.DischargeDate"
                            disableFuture={false}
                            required={false}
                            defaultlabelid="Discharge date*"
                            value={
                              values.dischargeDate
                                ? dayjs(values.dischargeDate)
                                : null
                            }
                            handlechange={(dateValue: Dayjs | null) => {
                              const formattedDate = dateValue?.isValid()
                                ? dateValue.format('YYYY-MM-DD')
                                : null;
                              const initialDischargeDate =
                                dischargeData?.dischargeDate ?? null;
                              setChanged(
                                formattedDate !== initialDischargeDate,
                              );
                              setFieldValue('dischargeDate', formattedDate);
                            }}
                            disabledDate={
                              !!(
                                tcsFlag ||
                                values.signature.signature ||
                                eicsAndTbrData.signature.rowKey ||
                                !hasEditPermission
                              )
                            }
                          />
                          {errors.dischargeDate && touched.dischargeDate && (
                            <Box className="loginError">
                              <MediumTypography
                                labelid={errors.dischargeDate}
                                className="errorText-md"
                              />
                            </Box>
                          )}
                        </Grid>
                        <Grid item xs={0.3}></Grid>
                        <Grid item xs={4}>
                          <DropdownComponent
                            name="dischargeReason"
                            names={transformedArrayDischareReason}
                            value={values.dischargeReason}
                            Required={false}
                            defaultlabelid="Dischare Reason"
                            labelid="EICS.DischargeReason"
                            handleChange={(value: string) => {
                              const newReason = value === '' ? null : value;
                              const initialReason =
                                dischargeData?.dischargeReason || null;
                              setChanged(newReason !== initialReason);
                              setFieldValue('dischargeReason', newReason);
                            }}
                            disabled={
                              !!(
                                tcsFlag ||
                                values.signature.signature ||
                                eicsAndTbrData.signature.rowKey ||
                                !hasEditPermission
                              )
                            }
                          />
                          {errors.dischargeReason &&
                            touched.dischargeReason && (
                              <Box className="loginError">
                                <MediumTypography
                                  labelid={errors.dischargeReason}
                                  className="errorText-md"
                                />
                              </Box>
                            )}
                        </Grid>
                        <Grid item xs={0.3}></Grid>
                        <Grid item xs={1}>
                          <Box className="flex__ alignItemCenter pt-xs">
                            <MediumTypography
                              onClick={() => navigation(EICS_TBR)}
                              labelid={'EICS'}
                              defaultlabel="EICS"
                              sxProps={{
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#008C82',
                                cursor: 'pointer',
                                pointerEvents: hasEditPermission
                                  ? 'auto'
                                  : 'unset',
                                opacity: hasEditPermission ? 'unset' : '1',
                              }}
                            />
                            <GoTo className="ml-xs" />
                          </Box>
                        </Grid>
                        <Grid item xs={4}>
                          <CheckBoxComponent
                            ischecked={values.includeDischargeInfoInNextEMR}
                            labelid="includeDischargeInfoInNextEMRText"
                            defaultlabelid="Include discharge information in next EMR"
                            CheckHandleChange={(
                              event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                              const checked = event.target.checked;
                              const initialChecked =
                                dischargeData?.includeDischargeInfoInNextEMR ??
                                false;
                              setChanged(checked !== initialChecked);
                              setFieldValue(
                                'includeDischargeInfoInNextEMR',
                                checked,
                              );
                            }}
                            disabled={Boolean(
                              tcsFlag ||
                                values.signature.signature ||
                                eicsAndTbrData.signature.rowKey ||
                                !hasEditPermission,
                            )}
                            className="font-bold"
                          />
                        </Grid>
                        {tcsFlag &&
                          values.signature.rowKey === '' &&
                          values.signature.signature === '' && (
                            <Grid item xs={12}>
                              <MediumTypography
                                className="font-bold mt-md"
                                labelid="clientDischargeFromTBRMessage"
                                defaultlabel="* Client is discharged in TBR"
                              />
                            </Grid>
                          )}
                      </Grid>
                    </Box>
                  </Box>

                  <Box>
                    {eicsAndTbrData.signature &&
                      (eicsAndTbrData.signature.rowKey !== '' ||
                        eicsAndTbrData.signature.signature) && (
                        <>
                          <ButtonComponent
                            className="btn-primary btn-cancel signature_view_Box"
                            labelId={'ProgressNote.ViewUpdateSignature'}
                            defaultLabelId={'View/update signature'}
                            variantType="outlined"
                            LeftIcon={<Editsignature />}
                            onClick={() => {
                              setSignClicked(true);
                            }}
                          />

                          {eicsAndTbrData?.signature?.name && (
                            <Box className="flex__ mt-lg">
                              <MediumTypography
                                label={`Approved by ${
                                  eicsAndTbrData.signature.name
                                } on ${dayjs(
                                  eicsAndTbrData.signature.date,
                                ).format('MM/DD/YYYY')}`}
                              />
                            </Box>
                          )}
                        </>
                      )}
                  </Box>
                </Card>

                {/* Signature pad */}
                {signClicked && (
                  <SignatureComponent
                    signClicked={signClicked}
                    labelId="signatureText"
                    defaultLabelId="Signature"
                    onCancelClick={onCancelClick}
                    signature={formRef.current?.values.signature.signature}
                    signaturePartitionKey={
                      formRef.current?.values.signature.partitionKey ?? ''
                    }
                    signatureRowKey={
                      formRef.current?.values.signature.rowKey ?? ''
                    }
                    signatureSaveOrUPdate={onSignatureSave}
                    resetCallBackForTypeEmployee={clearSignature}
                    signatureCallBack={signatureCallBack}
                    handleSuccess={handleSuccess}
                    type="Employee"
                    hideRemoveButton={
                      formRef.current?.values.signature.rowKey
                        ? handlePermissionCheck()
                        : true
                    }
                  />
                )}

                {/* {eicsAndTbrData.allowApprove && ( */}
                {!tcsFlag && (
                  <Box
                    component="div"
                    className="flex__ mt-md mb-md"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    {eicsAndTbrData.dischargeDate &&
                    eicsAndTbrData.dischargeReason ? (
                      <Box>
                        <ButtonComponent
                          className="btn-primary btn-submit"
                          labelId={'EICS.ApprovalBtn'}
                          defaultLabelId="Approve"
                          variantType="contained"
                          onClick={() => {
                            setApproveModal(true);
                          }}
                          disabled={
                            !(
                              eicsAndTbrData.allowApprove &&
                              values.signature.rowKey === '' &&
                              values.signature.signature === '' &&
                              values.dischargeApproved === false &&
                              !changed
                            )
                          }
                        />
                      </Box>
                    ) : (
                      <Box></Box>
                    )}

                    {hasEditPermission && (
                      <Box
                        className="flex__"
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                        }}
                      >
                        <ButtonComponent
                          className="btn-primary btn-cancel"
                          labelId={'Cancel'}
                          defaultLabelId="Cancel"
                          variantType="outlined"
                          onClick={() => {
                            if (
                              !_.isEqual(
                                eicsAndTbrData,
                                formRef.current?.values,
                              )
                            ) {
                              setCancelModal(true);
                            }
                          }}
                          disabled={!!values.signature.rowKey}
                        />
                        <ButtonComponent
                          className="btn-primary btn-submit ml-md"
                          labelId="ConsentSave"
                          defaultLabelId="Save"
                          variantType="contained"
                          onClick={handleSubmit}
                          disabled={!!values.signature.rowKey}
                        />
                      </Box>
                    )}
                  </Box>
                )}
                {/* )} */}
              </Box>
              {cancelModal && (
                <ModalPopup
                  open={cancelModal}
                  onCancel={() => {
                    setCancelModal(false);
                  }}
                  description="formUnsavedChangesMessage"
                  onOk={() => {
                    getTransitiondataFunction();
                    setCancelModal(false);
                  }}
                  labelId1="Clientpage.cancelbtn"
                  negativeActionLabel="cancelText"
                  labelId2="Clientpage.Okbtn"
                  positiveActionLabel="deleteText"
                />
              )}
              {approveModal && (
                <ModalPopup
                  open={approveModal}
                  onCancel={() => {
                    setApproveModal(false);
                  }}
                  description="EICS.ApprovalConfirmation"
                  onOk={() => {
                    setApproveModal(false);
                    setSignClicked(true);
                  }}
                  labelId1="Clientpage.Nobtn"
                  negativeActionLabel="No"
                  labelId2="Clientpage.Yesbtn"
                  positiveActionLabel="Yes"
                />
              )}
            </Box>
          </Box>
        );
      }}
    </Formik>
  );
}

export default EICSTBRTransitionAndDischargeInformation;
